import {createFileRoute, redirect} from "@tanstack/react-router";
import {RouteComponent} from "./-routeComponent";
import {ErrorComponent} from "./-errorComponent";
import {PendingComponent} from "./-pendingComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {isOrganizationWithDashboard, isOrganizationWithDashboardCustomDatefilter} from "~/utilities/organizationsWIthDashboard";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/dashboard",
)({
    beforeLoad: async ({context}) => {
        throw redirect({
            to: "/w/$workspaceId",
            params: {workspaceId: context.workspace.id},
        });
    },
    loader: async ({context}) => {
        // TODO: Remove after testing
        return {
        accessToken: context.authenticationStatus.accessToken,
            showCustomDateSelector: isOrganizationWithDashboardCustomDatefilter(context.workspace.id, context.environment),
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
